import {$$} from './util/$$';

const CAROUSEL_SELECTOR: string = '.js-carousel';
const ITEM_SELECTOR: string = '.js-carousel-item';
const NAVIGATION_SELECTOR: string = '.js-carousel-nav';

const ACTIVE_BUTTON_CLASS: string = 'active';
const ACTIVE_ITEM_CLASS: string = 'active';
const ANIMATING_ITEM_CLASS: string = 'slide';

const SLIDE_AUTOSTART: number = 4000;

class Carousel {
    private _activeIndex: number = 0;
    private _busy: boolean = false;
    private _timeout: number | undefined;
    private readonly _container: HTMLElement;
    private readonly _items: HTMLElement[];
    private readonly _buttons: HTMLElement[];

    constructor(container: HTMLElement) {
        this._container = container;
        this._items = this.getItems();
        this._buttons = this.createNavigation();

        this._timeout = window.setTimeout(
            this.next.bind(this),
            SLIDE_AUTOSTART,
        );
    }

    private next(): void {
        const next: number =
            this._activeIndex < this._items.length - 1
                ? this._activeIndex + 1
                : 0;

        this.navigateTo(next);
    }

    private navigateTo(index: number): void {
        if (
            this._activeIndex === index ||
            index < 0 ||
            index > this._items.length ||
            this._busy
        ) {
            return;
        }

        this._busy = true;
        window.clearTimeout(this._timeout);

        const oldItem: HTMLElement = this._items[this._activeIndex];
        const oldButton: HTMLElement = this._buttons[this._activeIndex];
        const newItem: HTMLElement = this._items[index];
        const newButton: HTMLElement = this._buttons[index];
        const listener: () => void = (): void => {
            newItem.removeEventListener('transitionend', listener);
            newItem.classList.remove(ANIMATING_ITEM_CLASS);

            oldItem.classList.remove(ACTIVE_ITEM_CLASS);

            this._activeIndex = index;
            this._busy = false;
        };

        newItem.addEventListener('transitionend', listener);
        newItem.classList.add(ANIMATING_ITEM_CLASS);
        newItem.classList.add(ACTIVE_ITEM_CLASS);

        oldButton.classList.remove(ACTIVE_BUTTON_CLASS);
        newButton.classList.add(ACTIVE_BUTTON_CLASS);

        this._timeout = window.setTimeout(
            this.next.bind(this),
            SLIDE_AUTOSTART,
        );
    }

    private createNavigation(): HTMLElement[] {
        const container: HTMLElement | null = this._container.querySelector(
            NAVIGATION_SELECTOR,
        );

        if (container === null) {
            return [];
        }

        return this._items.map(
            (item: HTMLElement, index: number): HTMLElement => {
                const child: HTMLElement = document.createElement('button');
                child.classList.add('c-carousel__nav__item');

                if (index === 0) {
                    child.classList.add('active');
                }

                child.innerText = `Carousel item ${index}`;
                child.addEventListener('click', (): void => {
                    this.navigateTo(index);
                });

                container.appendChild(child);

                return child;
            },
        );
    }

    private getItems(): HTMLElement[] {
        const items: HTMLElement[] = [];

        $$(ITEM_SELECTOR).forEach((element: HTMLElement): void => {
            items.push(element);
        });

        return items;
    }
}

export function carousel(): void {
    $$(CAROUSEL_SELECTOR).map(
        (element: HTMLElement): Carousel => {
            return new Carousel(element);
        },
    );
}
